module.exports = __webpack_public_path__ + "static/images/pay-logo.57414c5.png";